import { useCallback, useEffect, useState } from "react";
import client from "../api/client";

/**
 * Fetches the full state list once on mount, and provides a function to
 * fetch districts for a given state name on demand.
 *
 * Returns:
 *   states        – array of { state_name } objects (empty until loaded)
 *   districtsMap  – { [stateName]: string[] } cache accumulated across calls
 *   fetchDistricts(stateName) – loads districts for stateName if not cached yet
 */
export function useStatesDistricts() {
  const [states, setStates] = useState([]);
  const [districtsMap, setDistrictsMap] = useState({});

  useEffect(() => {
    client
      .get("get_all_states/")
      .then((data) => {
        if (Array.isArray(data?.state_list)) {
          setStates(data.state_list);
        } else if (Array.isArray(data)) {
          setStates(data);
        }
      })
      .catch(() => {});
  }, []);

  const fetchDistricts = useCallback((stateName) => {
    if (!stateName || districtsMap[stateName]) return;
    client
      .post("get_filtered_districts/", JSON.stringify({ state_name: stateName }))
      .then((data) => {
        const list = data?.district_list ?? data ?? [];
        if (Array.isArray(list)) {
          setDistrictsMap((prev) => ({ ...prev, [stateName]: list }));
        }
      })
      .catch(() => {});
  }, [districtsMap]);

  return { states, districtsMap, fetchDistricts };
}
